import React from "react";
import { useRef, useEffect } from "react";
import Dubai from "../../assets/icons/svg/1.svg";
import Dubai2 from "../../assets/icons/svg/2.svg";
import Dubai3 from "../../assets/icons/svg/3.svg";
import Dubai4 from "../../assets/icons/svg/4.svg";
import Dubai5 from "../../assets/icons/svg/5.svg";
import Dubai6 from "../../assets/icons/svg/6.svg";
import Dubai7 from "../../assets/icons/svg/7.svg";
import Dubai8 from "../../assets/icons/svg/8.svg";
import { NavLink } from "react-router-dom";
import SearchBar from "./SearchBar";

const Hero = ({ handleOrderPopup }) => {
  const countries = [
    { name: "Dubai", icon: Dubai, title: "Dubai Tour Package" },
    { name: "Bali", icon: Dubai2, title: "Bali Tour Package" },
    { name: "Thailand", icon: Dubai3, title: "Thailand Tour Package" },
    { name: "Singapore", icon: Dubai4, title: "Singapore Tour Package" },
    { name: "Japan", icon: Dubai5, title: "Japan Tour Package" },
    { name: "Malaysia", icon: Dubai6, title: "Malaysia Tour Package" },
    { name: "Paris", icon: Dubai7, title: "Paris Tour Package" },
    { name: "Brazil", icon: Dubai8, title: "Brazil Tour Package" },
  ];

  const typeArray = ["Travel", "Trip", "Adventure", "Thrill", "Journey"];
  const textRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const textElement = textRef.current;

    let currentWordIndex = 0;
    let letterCount = 1;
    let isTyping = true;

    const typeWord = () => {
      const currentWord = typeArray[currentWordIndex];
      if (isTyping) {
        textElement.textContent = currentWord.substring(0, letterCount);
        letterCount++;

        if (letterCount > currentWord.length) {
          isTyping = false;
          timerRef.current = setTimeout(() => typeWord(), 1000); // Pause before fade-out
        } else {
          timerRef.current = setTimeout(() => typeWord(), 150);
        }
      } else {
        letterCount--;
        textElement.textContent = currentWord.substring(0, letterCount);

        if (letterCount === 0) {
          currentWordIndex = (currentWordIndex + 1) % typeArray.length;
          isTyping = true;
          timerRef.current = setTimeout(() => typeWord(), 500); // Pause before next word
        } else {
          timerRef.current = setTimeout(() => typeWord(), 100);
        }
      }
    };

    typeWord();

    return () => clearTimeout(timerRef.current); // Cleanup on unmount
  }, []);

  const handleCountrySelect = (country) => {
    // Show the customized form for the selected country
    // Implement your form display logic here
    handleOrderPopup(); // Example function call to show the form
  };

  return (
    <div
      className="h-screen text-center flex justify-center w-full
    "
    >
      <div className="h-full flex flex-col justify-center items-center p-4">
        <div className="flex flex-wrap justify-center mt-8 md:mt-0 mb-12">
          {countries.map(({ name, icon, title }) => (
            <NavLink
              key={name}
              to={`/packages/${title}`} // Example link, adjust as needed
              className="flex transition-transform duration-300 hover:scale-125 group-hover:fill-current flex-col items-center group"
            >
              <img src={icon} alt={name} className="md:w-24 w-20" />
              <span className="text-white text-md font-semibold group-hover:text-indigo-500">
                {name}
              </span>
            </NavLink>
          ))}
        </div>
        <h1 className="flex flex-col text-white font-bold mb-2">
          <span className="md:text-6xl text-3xl font-normal">
            Time for your
          </span>{" "}
          <span className="md:text-7xl text-4xl font-extrabold">
            next{" "}
            <span
              ref={textRef}
              className="md:text-7xl text-4xl font-extrabold"
              style={{ color: "#5b53fb" }}
              // style={{ color: "#fb53d1" }}
            ></span>
          </span>
        </h1>
        <p className="text-white text-4xl font-semibold mb-6">
          Let us plan it for you
        </p>
        {/* <button
          className="bg-gradient-to-r from-primary to-teal-400 hover:bg-bg-gradient-to-r hover:from-secondary hover:scale-110 hover:bg-primary transition-all duration-600 text-white px-3 py-1 rounded-full"
          onClick={() => {
            handleOrderPopup();
          }}
        >
          Book Your Heaven
        </button> */}
        <SearchBar
          countries={countries}
          onCountrySelect={handleCountrySelect}
        />
      </div>
    </div>
  );
};

export default Hero;
